// YER GOREVI / EGITIM LOCATION KURALI — TEK KAYNAK.
//
// Serkan (31 Agu 2026): *"Egitimlerin location'i bilinir, egitim planlanmissa
//  yeri de bellidir, location secilmeli. Bizim gnd gorevleri belli zaten
//  office (zaten ana us), digerleri baska yerlerde olabilir."*
//
// Kural UC degerli, "var/yok" degil — cunku sorulacak SEY tipe gore degisiyor:
//
//   'none'  office : ana ustedir, sorulmaz.
//           dh     : 🔑 LOKASYON ZORUNLUDUR AMA BURADA SORULMAZ — Serkan
//                    (1 Eyl): *"DH'de zaten ICAO meydani girilmesi gerekli,
//                    orada da aslinda lokasyon zorunlu."* Olculdu: DH bacaklari
//                    `DEP/DEST required.` ve `Complete all sector fields.`
//                    kapilariyla ZATEN zorunlu (FTLPanel:1257 · 2252).
//                    Yani yer BOS DEGIL, baska bir alanda duruyor. Ayrica
//                    sormak ayni bilgiyi ikinci kez saklamak olurdu ve er ya
//                    da gec celisirdi (Ilke 3).
//                    ⚠️ 'none' burada "yeri yok" DEMEK DEGILDIR, "bu kutuda
//                    sorulmaz" demektir — kapi baska yerde.
//   'icao'  airport_standby : meydan nobeti tanimi geregi bir MEYDANDA.
//                    ICAO hem daha kesin hem `acclTz[ICAO]` zaten var.
//   'city'  training · sim · theoretical · other_standby : meydanda
//                    olmayabilir -> SEHIR/ULKE ("FARNBOROUGH/UK").
//
// Neden onemli: dinlenme / yerel gece / WOCL hesaplari dilim ALIYOR
// (`localNightsCovered(…, tz)`), ucus gorevlerinde dilim meydandan geliyordu;
// yer gorevlerinde HICBIR kaynak yoktu. Bu kural o kaynagi belirler.

export const LOCATION_KURALI = {
  office:          'none',
  dh:              'none',
  airport_standby: 'icao',
  training:        'city',
  sim:             'city',
  theoretical:     'city',
  other_standby:   'city',
};

/** Bu yer gorevi tipi icin location nasil sorulur: 'none' | 'icao' | 'city'.
 *  BILINMEYEN tip 'city' doner — yeni bir tip eklenip burasi unutulursa
 *  sistem SESSIZCE atlamaz, sorar (Ilke 1: eksik veriyle yesil gecilmez). */
export function locationKurali(groundKind) {
  const k = String(groundKind || '').toLowerCase();
  return LOCATION_KURALI[k] || 'city';
}

/** Kayit bu kurala gore TAM mi? Eksikse alan adiyla doner (Ilke 7: eksik
 *  ISIMLENDIRILEREK sayilir, genel "eksik var" mesaji degil). */
export function locationEksigi(groundKind, v = {}) {
  return kuralEksigi(locationKurali(groundKind), v);
}

/** OFF'un yeri (1 Eki 2026, Serkan: "OFF girilirken lokasyon da girilir" · "ICAO kod girelim") — meydan nöbetiyle
 *  AYNI kural. Boş = pilotun ana üssü (kaydederken yazılır); yazılmışsa meydan listede olmalı. */
export function offYeriEksigi({ location, location_tz } = {}) {
  if (!String(location || '').trim()) return null;
  return kuralEksigi('icao', { icao: location, locationTz: location_tz });
}

/** OFF'un yeri listede yoksa söylenen TEK cümle (ASSIGN · iptal → OFF). */
export const offYeriHataMetni = (icao) => `Day off location ${icao} is not in the airport list — check the ICAO code `
  + "(the two local nights are measured in that airport's time zone).";

/** Kuralın eksiği — kapı (`locationEksigi`) ve LOCATION seçicisinin zorunlu alan rengi AYNI ölçü (5 Eki 2026). */
export function kuralEksigi(kural, { location, locationTz, icao } = {}) {
  if (kural === 'none') return null;
  if (kural === 'icao') {
    if (String(icao || '').trim().length !== 4) return 'AIRPORT (ICAO)';
    // 1 Eki 2026: dilim kayda yazılır (LocationPicker, `meydanBilgisi`) — yoksa kod listede değildir ya da henüz
    //    okunmadı; yarı kayıt "girildi" sayılmaz (Ö-1 dersi).
    return String(locationTz || '').trim() ? null : 'AIRPORT TIME ZONE';
  }
  if (!String(location || '').trim()) return 'LOCATION';
  // Etiket var ama dilim yoksa hesap yapilamaz — bu bir yari-kayittir ve
  // "girildi" sayilmaz (Ö-1'in dersi: okunamayan alan sessizce gecilmez).
  if (!String(locationTz || '').trim()) return 'LOCATION TIMEZONE';
  return null;
}

/** Ekranda gorunen etiket: "FARNBOROUGH/UK". Veritabanindaki
 *  `duty_location_label()` ile AYNI kural — iki ayri birlestirme yazilmaz. */
export function locationEtiketi(city, countryCode) {
  const c = String(city || '').trim().toUpperCase();
  const k = String(countryCode || '').trim().toUpperCase();
  if (!c || !k) return '';
  return `${c}/${k}`;
}
